@if(mode === 'List'){
<app-page-container [DataTableSchema]="dataTableSchema" [title]="title" [dynamicFormArray]="filterSchema" [props]="props" [layoutType]="LayoutType.List" >
</app-page-container>
}

@if(mode === 'View'){
	<job-history-detail [dataSet]="dataSet" (dataEmitter)="onDetailViewChange($event)"></job-history-detail>
}